import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { RevokeAccountIntegrationRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { RevokeAccountIntegrationResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const revokeAccountIntegration = (request: RevokeAccountIntegrationRequest, options?: CashRequestOptions) =>
  post<RevokeAccountIntegrationRequest, RevokeAccountIntegrationResponse>(
    '/2.0/cash/revoke-account-integration',
    request,
    { ...options, rejectOnError: true }
  )
